// src/icons/AndroidLogo.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function AndroidLogo({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsxs("g", {
        clipPath: "url(#android-logo-a)",
        children: [
          /* @__PURE__ */ jsx("path", {
            d: "M2.77644 6.4783C2.43184 6.4783 2.13946 6.59847 1.89912 6.83881C1.65878 7.07915 1.53857 7.36756 1.53857 7.70416V12.8724C1.53857 13.2174 1.65874 13.5096 1.89912 13.7499C2.13946 13.9903 2.43184 14.1105 2.77644 14.1105C3.12079 14.1105 3.4114 13.9903 3.64801 13.7499C3.88416 13.5096 4.00256 13.2174 4.00256 12.8724V7.70416C4.00256 7.36752 3.88239 7.07915 3.64201 6.83881C3.40163 6.59847 3.11305 6.4783 2.77644 6.4783Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M12.7285 1.83878L13.5819 0.264526C13.6379 0.160304 13.618 0.0803828 13.522 0.0241852C13.4177 -0.0242736 13.3376 0.000281275 13.2816 0.0961138L12.4163 1.68296C11.6549 1.34631 10.8496 1.17768 10.0003 1.17768C9.15094 1.17768 8.34555 1.34635 7.58442 1.68296L6.71907 0.0961138C6.66284 0.000281275 6.58274 -0.0240566 6.47873 0.0241852C6.38247 0.080636 6.36254 0.160304 6.41877 0.264526L7.27219 1.83878C6.40684 2.28008 5.71764 2.89468 5.20485 3.6839C4.69205 4.47356 4.43555 5.33649 4.43555 6.2742H15.5531C15.5531 5.33671 15.2965 4.47374 14.7838 3.6839C14.2709 2.89468 13.5857 2.28008 12.7285 1.83878ZM7.79468 4.12857C7.70239 4.22107 7.59216 4.26711 7.46404 4.26711C7.33566 4.26711 7.22767 4.22107 7.13958 4.12857C7.05149 4.0365 7.00744 3.9267 7.00744 3.79814C7.00744 3.67002 7.05149 3.56001 7.13958 3.46772C7.22767 3.37565 7.33591 3.32961 7.46404 3.32961C7.59216 3.32961 7.70239 3.37565 7.79468 3.46772C7.88675 3.56023 7.933 3.67002 7.933 3.79814C7.93275 3.92649 7.88653 4.0365 7.79468 4.12857ZM12.8606 4.12857C12.7724 4.22107 12.6641 4.26711 12.5362 4.26711C12.4078 4.26711 12.2976 4.22107 12.2055 4.12857C12.1133 4.0365 12.0672 3.9267 12.0672 3.79814C12.0672 3.67002 12.1133 3.56001 12.2055 3.46772C12.2976 3.37565 12.4078 3.32961 12.5362 3.32961C12.6643 3.32961 12.7723 3.37565 12.8606 3.46772C12.9488 3.56023 12.9928 3.67002 12.9928 3.79814C12.9928 3.92649 12.9488 4.0365 12.8606 4.12857Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M4.4834 14.7113C4.4834 15.0803 4.61152 15.3926 4.86781 15.6489C5.12432 15.9051 5.43662 16.0333 5.80531 16.0333H6.69478L6.70697 18.7619C6.70697 19.1065 6.82714 19.3991 7.06748 19.6395C7.30782 19.8798 7.59644 20 7.93283 20C8.27721 20 8.56977 19.8798 8.81015 19.6395C9.05052 19.3991 9.17069 19.1065 9.17069 18.7619V16.0335H10.8293V18.7619C10.8293 19.1065 10.9494 19.3991 11.1898 19.6395C11.4302 19.8798 11.7225 20 12.0671 20C12.4115 20 12.7041 19.8798 12.9444 19.6395C13.1848 19.3991 13.3049 19.1065 13.3049 18.7619V16.0335H14.2064C14.5669 16.0335 14.8752 15.9054 15.132 15.6491C15.3882 15.3928 15.5164 15.0805 15.5164 14.7116V6.70645H4.4834V14.7113Z",
            fill: "currentColor"
          }),
          /* @__PURE__ */ jsx("path", {
            d: "M17.2235 6.4783C16.8868 6.4783 16.5984 6.5967 16.3581 6.83285C16.1177 7.06943 15.9976 7.36003 15.9976 7.70416V12.8724C15.9976 13.2174 16.1177 13.5096 16.3581 13.7499C16.5984 13.9903 16.887 14.1105 17.2235 14.1105C17.5678 14.1105 17.8604 13.9903 18.1008 13.7499C18.3412 13.5096 18.4613 13.2174 18.4613 12.8724V7.70416C18.4613 7.36 18.3412 7.06943 18.1008 6.83285C17.8604 6.5967 17.5678 6.4783 17.2235 6.4783Z",
            fill: "currentColor"
          })
        ]
      }),
      /* @__PURE__ */ jsx("defs", {
        children: /* @__PURE__ */ jsx("clipPath", {
          id: "android-logo-a",
          children: /* @__PURE__ */ jsx("rect", {
            fill: "white",
            height: 20,
            width: 20
          })
        })
      })
    ]
  });
}
export {
  AndroidLogo
};
//# sourceMappingURL=AndroidLogo.mjs.map